import React from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { trackPromise } from "react-promise-tracker";
import { AuthUserContext, withAuthorization } from "../Auth/Session";
import * as constantsRetreadBrand from "../../constants/actions/RetreadBrands";
import * as APIS from "../../constants/apis";
import RetreadBandNewItem from "./RetreadBands/RetreadBandNewItem";
import RetreadBandList from "./RetreadBands/RetreadBandList";

function getRetreadBrand(id) {
  let brand = {};
  let bands = [];
  return dispatch => {
    return trackPromise(fetch(`${APIS.API_REST_RETREADBRANDS}/${id}`, {
      headers: {
        "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
        "Accept-language": localStorage.getItem("LanguageSelected"),
      }
    })
      .then(response => response.json())
      .then(json => {
        brand = json;
        return fetch(APIS.API_REST_RETREADMODELS.replace("retreadbrand_id",
          brand.id), {
          headers: {
            "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
            "Accept-language": localStorage.getItem("LanguageSelected"),
          }
        });
      })
      .then(response => response.json())
      .then(json => {
        bands = json.RetreadBands;
        dispatch(onRetreadBrandSuccess({
          brand: brand,
          bands: bands
        }));
      })
      .catch(error => {
        toast.error(error.message.toString());
      }));
  }
}

export function onRetreadBrandSuccess(json) {
  return {
    type: constantsRetreadBrand.GET_BRAND_SUCCESS,
    json
  }
}

export function onReqSuccess(brands, brand, message) {
  const json = {
    brands: brands,
    brand: brand,
    message: message
  };
  return {
    type: constantsRetreadBrand.REQUEST_SUCCESS,
    json
  };
};

class RetreadBrandEditItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      customer_id: localStorage.getItem('GlobalCustomerId')
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    this.props.getRetreadBrand(id);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.brand || (this.props.brand !== prevProps.brand)) {
      this.setState({
        name: this.props.brand.name
      });
    }
  }

  onSubmit = event => {
    event.preventDefault();
    const { onReqSuccess, brands } = this.props;

    const id = this.props.match.params.id;
    const data = {
      ...this.state,
    };

    return trackPromise(fetch(`${APIS.API_REST_RETREADBRANDS}/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
        "Accept-language": localStorage.getItem("LanguageSelected"),
      },
      method: "PUT",
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(json => {
        const status = json.message;
        if (!status) {
          window.location.reload(false);
          onReqSuccess(brands, this.props.t("alerts.r-tire-item-2"));
        } else {
          throw new Error(status);
        }
      })
      .catch(error => {
        toast.error(error.message.toString());
      }));
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  showSuccessDialog = (message) => {
    if (!!message && !!toast) {
      toast.success(message);
    }
  };

  showErrorDialog = (error) => {
    if (!!error && !!toast) {
      toast.error(error);
    }
  };

  render() {
    const { brand, bands, message, error } = this.props;

    this.showErrorDialog(error);
    this.showSuccessDialog(message);
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          !!brand ?
            <div className="container-fluid mt-100">

              <h3>{ authUser.roles != "ANALYST" ? this.props.t("tire-retread.tire-edit") : this.props.t("tire-retread.tire-edit-see")}</h3>
              <br /><br />
              <form onSubmit={this.onSubmit}>
                <div className="form-group">
                  <div className="row">
                    <div className="col-sm-2">
                      <label htmlFor="nameInput">{this.props.t("tire-brands.tire-item-1")}</label>
                      <br></br><i className="text-info small">{this.props.t("globals.required")}</i>
                    </div>
                    <div className="col-sm-10">
                      <input className="form-control"
                        placeholder={this.props.t("tire-brands.tire-item-1")}
                        id="nameInput"
                        name="name"
                        value={this.state.name}
                        onChange={this.onChange}
                        required />
                      <input type="hidden"
                        name="customer_id"
                        value={this.state.customer_id} />
                    </div>
                  </div>
                </div>
                {
                  authUser.roles != "ANALYST" ?
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <button type="submit"
                        className="btn btn-primary">
                        <i className="fa fa-save"></i> {this.props.t("globals.simple-save")}
                    </button>
                    </div>
                  </div>
                  :
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <button type="button"
                        onClick={() => window.history.back()}
                        className="btn btn-primary">
                        <i className="fa fa-arrow-left"></i> {this.props.t("globals.back")}
                    </button>
                    </div>
                  </div>
                }
              </form>
              <br />
              {
                authUser.roles != "ANALYST" ?
                <>
                <h3>{this.props.t("tire-retread.tire-register-brand")}</h3>
                <RetreadBandNewItem t={this.props.t}/>
                </>
                :
                null
              }
              <br />
              <hr />
              <RetreadBandList brand={brand} t={this.props.t} authUser={authUser}
                bands={bands} />
            </div> : null
        )}
      </AuthUserContext.Consumer>
    );
  };
}

const structuredSelector = createStructuredSelector({
  brands: state => state.brands,
  brand: state => state.brand,
  bands: state => state.bands,
  message: state => state.message,
  error: state => state.error
});

const mapDispatchToProps = { getRetreadBrand, onReqSuccess };

const condition = authUser =>
  !!authUser;

export default withAuthorization(condition)(connect(structuredSelector, mapDispatchToProps)(RetreadBrandEditItem));
